import * as focusTrap from "focus-trap";

const menu = ($) => {
  const body = $("body");
  const MenuMobileWrapper = document.querySelector(".header__mobile-wrapper");
  const Burger = document.querySelector(".header__burger");
  const BtClose = document.querySelector(".header__close");
  const trapMenuMobile = focusTrap.createFocusTrap(MenuMobileWrapper);
  
  // Menu mobile - Toggle
  $(".js-toggleMenu").click((e) => {
    // Fermeture
    if (body.hasClass("is-menu-open")) {
      trapMenuMobile.deactivate();
      Burger.setAttribute("aria-expanded", "false");
      BtClose.setAttribute("aria-expanded", "true");
    }
    // Ouverture
    else {
      Burger.setAttribute("aria-expanded", "true");
      BtClose.setAttribute("aria-expanded", "false");

      // Trap-focus (after transition)
      setTimeout(() => {
        trapMenuMobile.activate();
      }, 500);
    }
    body.toggleClass("is-menu-open");
  });

  // Sous-menu A11Y
  const submenusContainer = $(".header__nav .menu-item-has-children");
  for (let i=0; i<submenusContainer.length; i++) {
    const trapSubMenu = focusTrap.createFocusTrap(submenusContainer[i]);
    
    $(submenusContainer[i]).find("button").click((e) => {
      const btn = $(e.currentTarget)
      const liParent = btn.parent('li');
  
      // Ouverture
      if (!liParent.hasClass('is-open')) {
        // Si nécessaire fermer les autres sous-menus
        if ($(".header__nav > ul > .is-open").length) {
          $(".header__nav > ul > .is-open").find('button').attr('aria-expanded', 'false');
          $(".header__nav > ul > .is-open").removeClass('is-open');
        }
        
        // Ouverture
        btn.attr('aria-expanded', 'true');
        if (btn.hasClass('focus-visible')) {
          trapSubMenu.activate();
        }
      }
      // Fermeture
      else {
        btn.attr('aria-expanded', 'false');
        if (btn.hasClass('focus-visible')) {
          trapSubMenu.deactivate();
        }
      }
      // Toggle class is-open on parent
      liParent.toggleClass('is-open');
    })
  }
};

export default menu;
